import confg from '@/setting'
import axios from 'axios'
import { ElMessage, ElLoading } from 'element-plus'

let toast:any = null // loading加载。。。
let count:any = 0 // 请求计数器
let timeId:any = null
const delayLoading:any = 1000

/* 开启loading 200ms之内返回数据不开启 loading */
function setDelayLoading () {
  clearTimeout(timeId)
  timeId = setTimeout(() => {
    toast = ElLoading.service({
      lock: true,
      fullscreen: true,
      text: '加载中...',
      background: 'transparent'
    })
    clearTimeout(timeId)
  }, delayLoading)
}

/* clear loading */
function clearLoading () {
  clearTimeout(timeId)
  if (count === 0 && toast) {
    toast.close()
  }
}

axios.interceptors.request.use(function (config) {
  config.baseURL = confg.BASE_URL
  config.timeout = 50000 // 请求超时
  /* 请求加1 */
  count++
  setDelayLoading()

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  /* 请求减1 */
  count--
  clearLoading()

  const {
    code,
    message
  } = response.data
  /* code 为 0 统一的错误业务状态码 */
  if (!code) {
    ElMessage.error({
      message: message
    })
  }
  /* 登录时账号或密码错误 */
  if (code === 10001) {
    ElMessage.error({
      message: message
    })
  }
  return response.data
}, function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '错误请求'
        break
      case 401:
        error.message = '未授权，请重新登录'
        break
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = '请求错误,未找到该资源'
        break
      case 405:
        error.message = '请求方法未允许'
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务器端出错'
        break
      case 501:
        error.message = '网络未实现'
        break
      case 502:
        error.message = '网络错误'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '网络超时'
        break
      case 505:
        error.message = 'http版本不支持该请求'
        break
      default:
        error.message = `未知错误,状态码：${error.response.status}`
    }
  } else {
    // error.messages = "连接到服务器失败";
  }

  // 发生错误关闭loading
  clearTimeout(timeId)
  if (toast) {
    toast.close()
  }

  // 取消发送请求的错误
  if (axios.isCancel(error)) {
    ElMessage.error({
      message: error.message
    })
    return
  }

  ElMessage.error({
    message: error.message
  })

  return Promise.reject(error)
})

export default axios
